import { MENU_ORDER_TYPE } from 'helpers/enums';

// Rules ship under either field name; resolve both here so the active check
// and the extra-minutes lookup can never read different lists.
export function getOrderTimeRules(orderSetup) {
  const rules =
    orderSetup?.orderTimeRules ?? orderSetup?.orderValueTimeAdjustRules;
  return Array.isArray(rules) ? rules : [];
}

export function isOrderValueTimeAdjustActive(orderSetup) {
  return (
    orderSetup?.isOrderValueTimeAdjustEnabled === true &&
    getOrderTimeRules(orderSetup).length > 0
  );
}

export function getExtraTimeFromOrderValue(amount, rules, orderType) {
  if (!rules || !Array.isArray(rules) || rules.length === 0) return 0;

  const isPickup = orderType === MENU_ORDER_TYPE.pickup;
  let extraTime = 0;

  const sortedRules = [...rules].sort(
    (a, b) => (a.minAmount || 0) - (b.minAmount || 0)
  );

  for (const rule of sortedRules) {
    if (rule.isEnabled && Number(amount) >= Number(rule.minAmount || 0)) {
      extraTime = isPickup
        ? Number(rule.extraMinutesPickup ?? 0)
        : Number(rule.extraMinutesDelivery ?? 0);
    }
  }

  return extraTime;
}

export function getEffectivePreparationTimes(orderSetup, orderAmount) {
  if (!isOrderValueTimeAdjustActive(orderSetup)) {
    
    return {
      deliveryTime: orderSetup?.deliveryTime
        ? Number(orderSetup.deliveryTime)
        : 0,
      pickUpTime: orderSetup?.pickUpTime ? Number(orderSetup.pickUpTime) : 0,
    };
  }

  const baseDelivery = Number(
    orderSetup?.deliveryTime || orderSetup?.defaultDeliveryTime || 60
  );
  const basePickup = Number(
    orderSetup?.pickUpTime || orderSetup?.defaultPickUpTime || 15
  );

  const rules = getOrderTimeRules(orderSetup);
  const extraDelivery = getExtraTimeFromOrderValue(
    orderAmount,
    rules,
    MENU_ORDER_TYPE.delivery
  );
  const extraPickup = getExtraTimeFromOrderValue(
    orderAmount,
    rules,
    MENU_ORDER_TYPE.pickup
  );

  return {
    deliveryTime: baseDelivery + extraDelivery,
    pickUpTime: basePickup + extraPickup,
  };
}
